import { StyleSheet } from 'react-native';

import { padding } from '@src/configuration/constants';

const styles = StyleSheet.create({
  contentContainer: {
    paddingBottom: padding,
  },
});

export default styles;
